import React, { FC } from 'react';
import clsx from 'clsx';
import { Box, CircularProgress } from '@material-ui/core';

import '../progress.scss';
import useMainProgressContext from './context/MainProgressContext';

const MainProgress: FC = () => {
  const { visibility } = useMainProgressContext();
  const classes = clsx({
    'Box-progress': true,
    'main': true,
    'show': visibility,
    'hide': !visibility,
  });

  return (
    <Box className={classes}>
      <CircularProgress className="CircularProgress-spinner" />
    </Box>
  );
};

export default MainProgress;
